const Role = {
    ADMIN: "admin",
    EMPLOYEE: "employee",
    SUPERVISOR: "supervisor",
    MANAGER: "manager",
    GM:"gm",
    SYSTEMADMIN: "system admin"
};
export default Role;
